import {
  GET_QUESTIONS_SUCCESS,
  CHECK_STATE_START,
  CHECK_STATE_SUCCESS,
  CHECK_STATE_ERROR,
  GET_REFERENCE_SUCCESS,
  DECLINE_REFERENCE_SUCCESS,
  CREATE_REFERENCE_SUCCESS
} from "../actions/workReferences.actions";

const INITIAL_STATE = {
  questions: [],
  referenceState: {},
  isReferenceStateLoading: false,
  reference: {}
};

export default function(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case GET_QUESTIONS_SUCCESS:
      return { ...state, questions: action.data };
    case CHECK_STATE_START:
      return { ...state, isReferenceStateLoading: true };
    case CHECK_STATE_SUCCESS:
      return {
        ...state,
        referenceState: action.data,
        isReferenceStateLoading: false
      };
    case CHECK_STATE_ERROR:
      return { ...state, isReferenceStateLoading: false };
    case GET_REFERENCE_SUCCESS:
      return { ...state, reference: action.data };
    case DECLINE_REFERENCE_SUCCESS:
      return { ...state };
    case CREATE_REFERENCE_SUCCESS:
      return { ...state };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/workReferences.reducer.js